// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"25":"c48fda68e30199ffc70e","221":"cdfd6922016c3d74314c","926":"90c63f89bf5aaf79313b"}[chunkId] + ".chunk.js";
};